import { render, staticRenderFns } from "./TrustedBy.vue?vue&type=template&id=294f937c&scoped=true&"
import script from "./TrustedBy.vue?vue&type=script&lang=ts&"
export * from "./TrustedBy.vue?vue&type=script&lang=ts&"
import style0 from "./TrustedBy.vue?vue&type=style&index=0&id=294f937c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "294f937c",
  null
  
)

export default component.exports